import PropTypes from 'prop-types';
import ToolTip, {tooltipPositions} from '../ToolTip.jsx';

import React from 'react';

import events from '../../../lib/events.js';

function formatAsHash(loc) {
  if (loc && loc.length > 0 && loc[0] === '#') {
    return loc;
  }
  return '#' + loc;
}

class Header extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    fallbackMainTitleReturn: PropTypes.string,
    intro: PropTypes.string,
    mainTitle: PropTypes.string.isRequired,
    mainTitleReturn: PropTypes.string,
    preTitle: PropTypes.any,
    preTitleReturn: PropTypes.string,
    subTitle: PropTypes.any,
    tagLine: PropTypes.any,
    tooltip: PropTypes.string,
    tooltipBody: PropTypes.node,
  };

  goBack = () => {
    window.history.back();
     // As per ticket KIKBIOLAB-400 use browsers back button
  };

  mainTitleReturn = (e) => {
    e.preventDefault();

    // Special case for support return from search
    if (this.props.mainTitleReturn === 'support' && window.location.hash === '#support' ||
        this.props.mainTitleReturn === 'encyclopedia' && window.location.hash === '#encyclopedia') {
      events.publish('supportclear');
    } else if (this.props.mainTitleReturn === undefined || this.props.mainTitleReturn === '') {
      this.goBack();
    } else {
      window.location.hash = this.props.mainTitleReturn;
    }
  };

  render() {
    let subTitle = this.props.subTitle ?
      <h1 className='heading-subtitle'>
        <img src='Content/img/chevron-small.png' alt='Chevron' className='heading-chevron'/>
        <span className='heading-subtitle-text'>{this.props.subTitle}</span>
      </h1> :
    null;

    let tagLine = this.props.tagLine ?
      <h1 className='heading-tagline'>
        <span className='heading-tagline-spacer'>|</span>
        <span className='heading-tagline-text'>{this.props.tagLine}</span>
      </h1> :
    null;

    // Pretitle : a smaller title above the main title that acts as the 'grandfather' page
    let preTitle =
      <div>
        {this.props.preTitle ?
          <a className='heading-pretitle' href={formatAsHash(this.props.preTitleReturn)}>
            {this.props.preTitle}
          </a> :
        null}
      </div>

    ;

    // The mainTitle will have 'back' functionality only if a subTitle exists
    let header =
      <div>
        <h1>
          {this.props.subTitle ? <a style={{marginRight: '0px'}} href={formatAsHash(this.props.mainTitleReturn || this.props.fallbackMainTitleReturn)}
          onClick={this.mainTitleReturn}>{this.props.mainTitle}
          </a> : <div>{this.props.mainTitle}</div>}
        </h1>
        {subTitle}
        {tagLine}
        {this.props.tooltip || this.props.tooltipBody ?
          <ToolTip title={this.props.tooltip} body={this.props.tooltipBody}
          position={tooltipPositions.leftTop} iconOnly style={{float: 'right', marginTop: 15}} /> : null}
        {this.props.intro ? <div className='header-intro'>{this.props.intro}</div> : null}
      </div>;

    return (
      <div className='row'>
        <div className='col-xs-12'>
          {preTitle}
        </div>
        <div className='col-xs-12'>
          <div className='header-wrapper' style={{marginLeft: null}}>
            {header}
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
